import { render, staticRenderFns } from "./AppSicFooter.vue?vue&type=template&id=52658b0b&scoped=true&lang=pug&"
import script from "./AppSicFooter.vue?vue&type=script&lang=js&"
export * from "./AppSicFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppSicFooter.vue?vue&type=style&index=0&id=52658b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52658b0b",
  null
  
)

export default component.exports